var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import * as Styled from "./DetailStyles";
var Detail = function (_a) {
    var className = _a.className, children = _a.children, size = _a.size, bold = _a.bold, textTransform = _a.textTransform, withoutMargins = _a.withoutMargins, props = __rest(_a, ["className", "children", "size", "bold", "textTransform", "withoutMargins"]);
    return (React.createElement(Styled.Detail, __assign({ size: size, bold: bold, textTransform: textTransform, withoutMargins: withoutMargins }, props), children));
};
export default Detail;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGV0YWlsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiRGV0YWlsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDL0IsT0FBTyxLQUFLLE1BQU0sTUFBTSxnQkFBZ0IsQ0FBQztBQVd6QyxJQUFNLE1BQU0sR0FBRyxVQUFDLEVBUU47SUFQUixJQUFBLFNBQVMsZUFBQSxFQUNULFFBQVEsY0FBQSxFQUNSLElBQUksVUFBQSxFQUNKLElBQUksVUFBQSxFQUNKLGFBQWEsbUJBQUEsRUFDYixjQUFjLG9CQUFBLEVBQ1gsS0FBSyxjQVBNLDRFQVFmLENBRFM7SUFFUixPQUFPLENBQ0wsb0JBQUMsTUFBTSxDQUFDLE1BQU0sYUFDWixJQUFJLEVBQUUsSUFBSSxFQUNWLElBQUksRUFBRSxJQUFJLEVBQ1YsYUFBYSxFQUFFLGFBQWEsRUFDNUIsY0FBYyxFQUFFLGNBQWMsSUFDMUIsS0FBSyxHQUVSLFFBQVEsQ0FDSyxDQUNqQixDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsZUFBZSxNQUFNLENBQUMifQ==